import React, { useContext, useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import moment from 'moment';
import "../DataCollection/style.css";
import Swal from 'sweetalert2';
import AuthContext from '../../auth/authContext';
import TODIS_FORM from './form';
import Iframe from 'react-iframe';
import { UrlServicesGraphic } from "../../.config";
import { VscChevronRight } from "react-icons/vsc";
import { VscSymbolColor } from "react-icons/vsc";
import { Button } from "react-bootstrap";
import TODIS_FORM_KPI from "./formKPI";
import style from "./form.module.scss";
import html2canvas from "html2canvas";
import jsPdf from "jspdf";
import downloadjs from 'downloadjs';

const valor = new BroadcastChannel("idform");
const closed = new BroadcastChannel("closed");
const valueKPI = new BroadcastChannel("idKPI");
const messages = new BroadcastChannel("messages");
const messagesuccess = new BroadcastChannel("messagesuccess");
const grafic = new BroadcastChannel("grafic");
const Sharing = ({ type,token }) => {
    const iframeRef = useRef(null);

    const [flagForm, setFlagForm] = useState(false);
    const [fullMap, setfullMap] = useState(false);
    const [resultTable, setresultTable] = useState(false);
    const [filterData, setfilterData] = useState({});
    const [request, setrequest] = useState(null);
    const [typeForm, setTypeForm] = useState("LIVE");
    //const [filterData2, setfilterData2] = useState({});
    const [filterDataExport, setfilterDataExport] = useState({});
    const { state, user } = useContext(AuthContext);
    const [typeFilter, setTypeFilter] = useState("");
    const [typeKPI, setTypeKPI] = useState("");
    const [filterKPI, setFilterKPI] = useState({ regionalPartner: "", sector: "", networkType: "", tentCategory: "", yearInit: "", yearEnd: "" })
    const [url, seturl] = useState("");
    const [urlGraphic, seturlGraphic] = useState("");

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    var intervalId = setInterval(function () {
        var currentTimeInSeconds = Math.floor(Date.now() / 1000);

        if (currentTimeInSeconds % 2 === 0 && document.activeElement === document.getElementById('contentIFrame')) {
            localStorage.setItem('lastInteractionTime', moment().toISOString());
            setTimeout(function () { window.focus(); }, 0);
        }
    }, 20000);

    var eventListener = window.addEventListener('blur', function () {
        var currentTimeInSeconds = Math.floor(Date.now() / 1000);

        if (currentTimeInSeconds % 2 === 0 && document.activeElement === document.getElementById('contentIFrame')) {
            localStorage.setItem('lastInteractionTime', moment().toISOString());
            setTimeout(function () { window.focus(); }, 0);
        }
        window.removeEventListener('blur', eventListener);
    });


    const expanding = () => {
        //console.log("expanding from parent");
        setfullMap(!fullMap);
    }
    const imprimirFiltering = async () => {
        //var iframes = document.querySelector("iframe"); //te da los Iframes de la pagina
        var iframes = document.getElementById("filtering");
        var iframeDocument = iframes.contentWindow.document;
        var contenido = iframeDocument.body;
        //contenido.querySelectorAll(".header-panel").forEach(e => e.remove());

        const canvas = await html2canvas(contenido);
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, 'download.png', 'image/png');
    }
    const sendFilterData = (data) => {
        setfilterData(data);
    }

    const sendFilterDataExport = (data) => {
        //console.log(data);
        setfilterDataExport(data);
    }

    const expandingResultTable = (showTable) => {
        //console.log("expandingResultTable from parent");
        setresultTable(showTable);
    }

    const requestData = (data) => {
        //console.log("set request "+data);        
        setrequest(data);
    }

    const typeFormData = (data) => {
        //console.log("set typeFormData "+data);
        setTypeForm("NETWORKPERFORMING");
    }
    closed.onmessage = function (ev) {
        setfullMap(false);
    };
    valor.onmessage = function (ev) {
        console.log(ev);
        setTypeForm(ev.data[0]);
        setrequest(ev.data[1]);
        setFlagForm(ev.data[3]);
        if (!fullMap) {
            setfullMap(true);
        }
        setTypeFilter("form")
        const Extent = new BroadcastChannel("MapaExtent");
        var params = {
            data: ev.data[2],
            type: "type"
        }
        Extent.postMessage(params);
    };

    messages.onmessage = function (ev) {
        Toast.fire({
            icon: 'warning',
            title: ev.data
        })
    };
    messagesuccess.onmessage = function (ev) {
        Toast.fire({
            icon: 'success',
            title: ev.data
        })
    };
    valueKPI.onmessage = function (ev) {
        if (!fullMap) {
            setfullMap(true);
        }
        setFilterKPI(ev.data.listValues)
        setTypeKPI(ev.data.type)
        setTypeFilter("kpi")
    };

    grafic.onmessage = function (ev) {
        let Params = "";
        if (!fullMap) {
            setfullMap(true);
        }
        if (ev.data[1] != "0") {
            Params = "#rp=" + ev.data[1];
        }
        else {
            Params = "#rp=";
        }
        if (ev.data[2] != "0") {
            Params += "&y=" + ev.data[2] + ",";
        }
        else {
            Params += "&y=";
        }
        if (ev.data[7] != "0") {
            Params += "&te=" + ev.data[7];
        }
        else {
            Params += "&te=";
        }
        if (ev.data[0] == 87) {
            if (ev.data[3] != "0") {
                Params += "&ca=" + ev.data[3];
            }
            else {
                Params += "&ca=";
            }
            if (ev.data[4] != "0") {
                Params += "&pa=" + ev.data[4];
            }
            else {
                Params += "&pa=";
            }
        }
        if (ev.data[0] == 88) {
            if (ev.data[5] != "0") {
                Params += "&ca=" + ev.data[5];
            }
            else {
                Params += "&ca=";
            }
            if (ev.data[6] != "0") {
                Params += "&pa=" + ev.data[6];
            }
            else {
                Params += "&pa=";
            }
        }
        console.log(Params);
        seturlGraphic(UrlServicesGraphic[ev.data[0]] + Params);

        setTypeFilter("graf");
    };
    useEffect(() => {        

        let typeTransport = "";
        let regionalPartner = "";
        let transport = "";
        let permission = user.permissions.find(item => item.id = 1);
        let objetoParaEnviar = null;
        permission.permissions.map(item => {
            transport = transport + item.id + ",";
            item.permissions.map(item => {
                typeTransport = typeTransport + item.id + ",";
            })
        })
        user.regionalPartner.map(item => {
            regionalPartner = regionalPartner + "'" + item.countrycode + "'" + ",";

        })

        typeTransport = typeTransport.substring(0, typeTransport.length - 1);
        regionalPartner = regionalPartner.substring(0, regionalPartner.length - 1);
        transport = transport.substring(0, transport.length - 1);

        objetoParaEnviar = {
            regionalPartner: regionalPartner,
            typeTransport: typeTransport,
            transport: transport,
            userid: user.id,
            username: user.username
        };

        localStorage.setItem('sendobject', JSON.stringify(objetoParaEnviar));

        //seturl("https://todis.transport-community.org/web_gis/?regionalPartner="+regionalPartner+"&typeTransport="+typeTransport+"&transport="+transport);
        seturl("https://todis.transport-community.org/web_gis/?token="+token);

        document.getElementById("IframeParent").onclick = function () { console.log("Helloooo"); }
    }, [])
    return (
        <Container fluid className="col-sm-12">

            <Row style={{ height: "100%" }}>
                <Col style={{ paddingRight: 0 }} sm={fullMap ? 7 : 12} id="IframeParent">
                    <Iframe
                        url={url}
                        width="100%"
                        height="100%"
                        id="contentIFrame"
                        className=""
                        display="block"
                        position="relative"
                    />
                </Col>

                {fullMap &&
                    <>
                        <Col style={{ padding: 0, width: '1.333333%', flex: '0 0 auto' }}><div style={{ paddingTop: "40vh", paddingLeft: "4px" }}><div style={{ display: "flex", alignItems: "center", borderRadius: "15px 0px 0px 15px", backgroundColor: "#004494", height: "100px" }} onClick={expanding}><VscChevronRight size="23" color="white" /></div>
                            {typeFilter != "kpi" && typeFilter != "form" && <div style={{ display: "flex", alignItems: "center", borderRadius: "15px 0px 0px 15px", backgroundColor: "#004494", height: "100px" }} onClick={imprimirFiltering}><VscSymbolColor size="23" color="white" /></div>}</div></Col>
                        {/* <div onClick={expanding} style={{color:"red",marginTop:"35%"}}>hola</div> */}
                        <Col style={{ paddingLeft: 0, width: '40.333333%', flex: '0 0 auto' }} >
                            {typeFilter == "form" ?

                                <TODIS_FORM type={typeForm} request={request} expanding={expanding} fullMap={fullMap} flagForm={flagForm} />
                                : typeFilter == "kpi" ?
                                    <TODIS_FORM_KPI filter={filterKPI} type={typeKPI} />
                                    :
                                    <div id="grafico" className={`${style.imprimir}`} style={{ height: "100%" }}>
                                        <Iframe url={urlGraphic}
                                            width="100%"
                                            height="100%"
                                            name=""
                                            id="filtering"
                                            display="block"
                                            position="relative" />
                                    </div>
                            }
                        </Col>
                    </>
                }
            </Row>
        </Container>
    );
}

export default Sharing;